import { useAuthStore } from './authStore';
import { getEntraAccessToken, isEntraConfigured, logoutEntra } from './msal';

/** The one surface the rest of the app uses; Entra is behind it (msal.ts). */
export async function getValidAccessToken(): Promise<string | null> {
  return isEntraConfigured() ? getEntraAccessToken() : null;
}

export async function logout(): Promise<void> {
  await logoutEntra();
}

/** Signed-in user name for display. */
export function useUsername(): string | undefined {
  return useAuthStore((s) => s.session?.username);
}

export function useSignedIn(): boolean {
  return useAuthStore((s) => Boolean(s.session));
}
